import browniePointsDefault from './browniePointsDefault'

const isQuicksticksSite =
  import.meta.env.VITE_WHITE_LABEL === 'jicp' ||
  import.meta.env.VITE_WHITE_LABEL === 'sef' ||
  window.location.href.indexOf('jicp.browniepoints.africa') > -1 ||
  window.location.href.indexOf('sef.browniepoints') > -1 ||
  window.location.href.indexOf('https://quicksticks.io') > -1 ||
  window.location.href.indexOf('goodeconomy.browniepoints') > -1 ||
  window.location.href.indexOf('sef-develop--browniepointsafrica') > -1 ||
  window.location.href.indexOf('sef-develop.browniepoints') > -1

const localize = (string, count) => {
  try {
    return browniePointsDefault(string, count)
  } catch (err) {
    throw new Error(`Localization error for ${string}`)
  }
}

// capitalize
export const c = string => string.charAt(0).toUpperCase() + string.slice(1)

// Uppercase
export const u = string => string.toUpperCase()

// Restrict features only to SEF site
export const isSef = isQuicksticksSite
export const isEmploymentSite =
  window.location.href.indexOf('employment.browniepoints') > -1 ||
  window.location.href.indexOf('employment.quicksticks.io') > -1
export const isShiftLogSite =
  window.location.href.indexOf('time.browniepoints') > -1 ||
  window.location.href.indexOf('time.quicksticks.io') > -1
export const isTimekeeperSite =
  window.location.href.indexOf('timekeeper.browniepoints') > -1 ||
  window.location.href.indexOf('timekeeper.quicksticks.io') > -1

export const isSefEmployee =
  import.meta.env.VITE_WHITE_LABEL === 'sef' ||
  window.location.href.indexOf('sef-employees.browniepoints') > -1 ||
  window.location.href.indexOf('employment.browniepoints') > -1 ||
  window.location.href.indexOf('https://quicksticks.io') > -1 ||
  window.location.href.indexOf('browniepoints.datafree.co') > -1

export const canDisplayFeature = false

export const isDgmt =
  import.meta.env.VITE_WHITE_LABEL === 'dgmt' ||
  window.location.href.indexOf('data-free.org.za') > -1 ||
  window.location.href.indexOf('browzafree.org.za') > -1 ||
  window.location.href.indexOf('dgmt.browniepoints') > -1 ||
  window.location.href.indexOf('dgmt-sir.browniepoints') > -1

export const isLevelUp =
  import.meta.env.VITE_WHITE_LABEL === 'levelup' ||
  window.location.href.indexOf('levelup.browniepoints') > -1 ||
  window.location.href.indexOf('lvlup.africa') > -1

export const siteName = isDgmt ? 'Data-Free' : 'Brownie Points'

export default localize
